import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';

const useQuickBook = () => {
  const updateToken = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/update-token`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getProfitRevenue = useCallback(async (params) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      return await ajax.get(`quickbook/get-profit-ytd?${queryString}`, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getProfitRevenuePrevYear = useCallback(async (payload) => {
    try {
      return await ajax.get(`quickbook/get-profit-prev-year`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalProfitRevenue = useCallback(async (payload) => {
    try {
      return await ajax.get(`quickbook/get-total-profit-revenue`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalPastDueInvoices = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-invoices`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getCronQbFieldsByCell = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/set-qb-fields-by-cell`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const pastDueTableByCell = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-table-for-cell`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const pastDueTableByCountry = useCallback(async (payload) => {
    try {
      return await ajax.post(`quickbook/get-past-due-table-for-country`, payload, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const getTotalPastDueInvoicesForAllCells = useCallback(async () => {
    try {
      return await ajax.post(`quickbook/get-past-due-invoices-for-all-cells`, {
        networkParams: { showLoader: true },
      });
    } catch (error) {
      console.log(error);
    }
  });

  const authUri = useCallback(async (val) => {
    try {
      return await ajax.get(`auth/authUri`, val);
    } catch (error) {
      return error;
    }
  });

  const callback = useCallback(async (val) => {
    try {
      return await ajax.get(`auth/callback`, val);
    } catch (error) {
      return error;
    }
  });

  const report = useCallback(async (val) => {
    try {
      return await ajax.post(`auth/report`, val);
    } catch (error) {
      return error;
    }
  });

  const reportForQuarters = useCallback(async (val) => {
    try {
      return await ajax.post(`auth/report-for-quarters`, val);
    } catch (error) {
      return error;
    }
  });

  return {
    authUri,
    callback,
    report,
    reportForQuarters,
    updateToken,
    getProfitRevenue,
    getProfitRevenuePrevYear,
    getTotalProfitRevenue,
    getTotalPastDueInvoices,
    getCronQbFieldsByCell,
    getTotalPastDueInvoicesForAllCells,
    pastDueTableByCell,
    pastDueTableByCountry,
  };
};

export default useQuickBook;
